import { Injectable } from '@angular/core';
import {environment} from '../../../../environments/environment';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LogDocumentoService {
  urlBase: String = `${environment.urlBase}/log-documento`

  constructor(private  http: HttpClient) { }

  buscarLogDocumentoPorParceiro(idParceiro: number | undefined, idColigada: number | undefined): Observable<any> {
    return this.http.get(`${this.urlBase}/log-documento/parceiro/${idParceiro}/coligada/${idColigada}`);
  }

  buscarLogDocumentoPorDocumento(documentoUuid: string): Observable<any> {
    const params = new HttpParams().set('uuid', documentoUuid);
    return this.http.get(`${this.urlBase}/log-documento/documento`, { params });
  }
}
